/// <reference path="../typings.d.ts" />
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppTitle } from './title';
import { Account, validateToken } from './account.service';
import { OneRosterService } from './oneroster.service';
import { Alert } from './alert';
import { Config } from './config';
import { AppService } from './app.service';

@Component({
	selector: 'login',
	template:
		`<div class="col-lg-3 col-md-6 col-xs-12">
      <alert [alert]="msg"></alert>
   </div>`
})

export class LoginComponent implements OnInit, OnDestroy {
	public msg: Alert;

	constructor(
		private router: Router,
		private title: AppTitle,
		private account: Account,
		private dvc: OneRosterService,
		private config: Config,
		private app: AppService,
	) {
		this.msg = new Alert();
		title.setTitles({ title: 'Login', dashboard: 'Login' });
		title.setBreadcrumbs([
			{ title: 'Login', link: '' }
		]);
	}

	ngOnInit() {
        let gotopage = this.config.goToPage(); // This should retrieve the original URL from query params or storage
        let preferredAcctNumber: string = null;

        if (gotopage) {
            // Attempt to extract acctNumber from the gotopage URL path
            // Assuming URL format like /<route_prefix>/<acctNumber>/...
            const pathSegments = gotopage.split('/');
            if (pathSegments.length >= 3) {
                // Add other relevant prefixes if any routes use acctNumber in this position
                const routePrefixes = ['settings', 'reports', 'users', 'subscription'];
                if (routePrefixes.indexOf(pathSegments[1]) !== -1) {
                    preferredAcctNumber = pathSegments[2];
                }
            }
        }

        if (validateToken()) {
            // Pass the extracted preferredAcctNumber to loadUser
            this.dvc.loadUserByAcctNumber(preferredAcctNumber).subscribe(ur => { // 'ur' is the UserRoles that was actually set
                let us = this.account.getUser();
                // This check might be redundant if loadUser always returns a UserRoles or throws an error
                if (ur == null && us == null) {
                    this.msg.error('You don\'t have access to this page.');
                    this.account.removeLocalStorage();
                    return;
                }

                // trigger app component to reload some of the ui parts
                this.app.onLoadApp.emit(null);

                // Navigate to the original page if it was specified and the account number was successfully loaded
                // Otherwise, navigate to the default settings page for the loaded account.
                if (gotopage && preferredAcctNumber && ur.acctNumber === preferredAcctNumber) {
                    this.router.navigateByUrl(gotopage);
                } else {
                    this.router.navigateByUrl(`/settings/${ur.acctNumber}/registrations`);
                }

            }, err => {
                if (err.message == 'unauthorized') {
                    this.msg.error('You don\'t have access to this page.');
                } else {
                    this.msg.error('There is an error when processing this request, please try again.');
                }
            });

        } else {
            this.msg.error('Invalid token, please logout and login again.');
        }
    }

	ngOnDestroy() {
		this.config.removeLocalStorage();
	}
}
